import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import { CompanyDetailsFooter } from '@/components/CompanyDetailsFooter';
import { LAYOUT_NOTES } from '@/constants/campaign-notes';
import { amplitudeModule } from '@/modules/amplitude';
import { webCampaign } from '@/modules/webCampaign';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { INTERACTION_OPTIONS, SAFE_INTERACTIONS } from './constants';

const InteractionStyles = styled(OnboardingPage)``;

export const ScreenInteraction: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Interaction',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const interaction = form.watch('interaction');
  const gender = form.watch('gender');

  const layoutNotes = webCampaign.getLayoutNotes();
  const shouldShowSafeInteractions = layoutNotes.includes(
    LAYOUT_NOTES.SAFE_INTERACTIONS,
  );
  const interactionOptions = shouldShowSafeInteractions
    ? SAFE_INTERACTIONS
    : INTERACTION_OPTIONS;

  const handleChange = (
    option: OnbOptionType<LayoutDataType['interaction']>,
  ) => {
    userService.createOrUpdate({
      onboarding_data: {
        interaction: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  const handleBackStep = (): void => {
    wizard.goToStep(gender === 'male' ? 'about_look' : 'hair_color');
  };

  return (
    <InteractionStyles>
      <OnboardingNavigation onBack={handleBackStep} />

      <IonContent>
        <OwnAiTitle>What kind of interactions do you enjoy?</OwnAiTitle>
        <OnboardingOptionsList>
          {interactionOptions.map((option) => (
            <OnboardingOptionItem
              checked={interaction === option.id}
              control={form.control}
              option={option}
              name="interaction"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`interaction-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>

      <CompanyDetailsFooter extraPadding />
    </InteractionStyles>
  );
};
